export const ENTRY_POINT = {
    BUNDLE: 'bundle',
    PROMO: 'promo',
    LANDING: 'landing',
    IFRAME: 'iframe',
    OVERVIEW: 'overview',
} as const;

export type EntryPointKey = keyof typeof ENTRY_POINT;
export type EntryPointValue = (typeof ENTRY_POINT)[EntryPointKey];

export const { BUNDLE, PROMO, LANDING, IFRAME, OVERVIEW } = ENTRY_POINT;
